import { GoabIcon } from "@abgov/react-components";
import { IconButton, InputAdornment,  Popover } from "@mui/material";
import { DateCalendar, DateField } from "@mui/x-date-pickers";
import React, { useCallback, useEffect } from "react";
import { useRef, useState } from "react";
import { dateFormat, tz } from "../../constants";
import { createFieldTestId, createButtonTestId } from "../../utils/testIds";


export const CustomFmF = ({ onChange, onBlur, value, name, error, ...otherProps }: any) => {

    const dateRef = useRef<any>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const handleBlur = useCallback((_e: any) => {
        handlePickerClose();
        if (typeof onBlur === 'function') {
            onBlur({ target: { name } })
        }
    }, [name, onBlur]);

    useEffect(() => {
        if (dateRef?.current?.onblur) {
            dateRef.current.onblur = handleBlur;
        }
    }, [dateRef, handleBlur])
    
    const openPicker = Boolean(anchorEl);
    const pickerId = 'calendar-popover';
    const handleChange = (_fieldName: any, value: any) => {
        if (typeof onChange === 'function') {
            onChange({ target: { value, name } })
        }
        handlePickerClose()
    };

    const handlePickerClick = (_event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(dateRef.current);
    };

    const handlePickerClose = () => {
        setAnchorEl(null);
    };
    
    return (
        <div className={error ? "date-error": ""} data-testid={createFieldTestId(`date-picker-${name}`)}>
            <DateField
                ref={dateRef}
                value={value}
                clearable={true}
                name={name}
                timezone={tz}
                format={dateFormat}
                onBlur={handleBlur}
                data-testid={createFieldTestId(`date-input-${name}`)}
                onChange={(value:any) => {
                    const testDate = new Date(value);
                    if (testDate.toString() !== 'Invalid Date') {
                        handleChange(name, value || null)
                    }
                }}
                slotProps={{
                    textField: {
                        InputProps: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton data-testid={createButtonTestId(`calendar-${name}`)} onClick={handlePickerClick} aria-label="open calendar">
                                        <GoabIcon type="calendar" />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },
                    },
                }}
                {...otherProps} />
            <Popover
                id={pickerId}
                open={openPicker}
                anchorEl={anchorEl}
                onClose={handleBlur}
                data-testid={createFieldTestId(`date-popover-${name}`)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <DateCalendar value={value}
                    data-testid={createFieldTestId(`date-calendar-${name}`)}
                    onChange={(value:any) => {
                        handleBlur({ target: { name } });
                        handleChange(name, value);
                    }} />
            </Popover>
        </div>
    )
}